import { NacinPlacanjaModalUpdateComponent } from './nacin-placanja/nacin-placanja-modal-update.component';
import { MestoView } from './mesto/mesto-view';
import { DrzavaComponent } from "./drzava/drzava.component";
import { Drzava } from "./drzava/drzava";
import { DrzavaModalUpdateComponent } from "./drzava/drzava-modal-update.component";
import { ModalSize, RefreshType, ColumnType, FormType, DefaultListType, CanDeactivateGuard, PrintType, ColumnAligment } from "yt-ng-framework";
import { Routes } from "@angular/router";
import { Roba } from "./roba/roba";
import { RobaModalUpdateComponent } from "./roba/roba-modal-update.component";
import { RobaComponent } from "./roba/roba.component";
import { JedinicaMereModalUpdateComponent } from './jedinica-mere/jedinica-mere-modal-update.component';
import { JedinicaMereComponent } from './jedinica-mere/jedinica-mere.component';
import { JedinicaMere } from "./jedinica-mere/jedinica-mere";
import { KomitentModalUpdateComponent } from './komitent/komitent-modal-update.component';
import { KomitentComponent } from './komitent/komitent.component';
import { Komitent } from "./komitent/komitent";
import { MagacinComponent } from './magacin/magacin.component';
import { Magacin } from "./magacin/magacin";
import { MagacinModalUpdateComponent } from './magacin/magacin-modal-update.component';
import { MestoComponent } from './mesto/mesto.component';
import { Mesto } from "./mesto/mesto";
import { MestoModalUpdateComponent } from './mesto/mesto-modal-update.component';
import { Okrug } from './okrug/okrug';
import { OkrugModalUpdateComponent } from './okrug/okrug-modal-update.component';
import { OkrugComponent } from './okrug/okrug.component';
import { OpstinaComponent } from './opstina/opstina.component';
import { Opstina } from './opstina/opstina';
import { OpstinaModalUpdateComponent } from './opstina/opstina-modal-update.component';
import { TipKomitentaComponent } from "./tip-komitenta/tip-komitenta.component";
import { TipKomitenta } from "./tip-komitenta/tip-komitenta";
import { TipKomitentaModalUpdateComponent } from "./tip-komitenta/tip-komitenta-modal-update.component";
import { VrstaKomitentaComponent } from "./vrsta-komitenta/vrsta-komitenta.component";
import { VrstaKomitentaModalUpdateComponent } from "./vrsta-komitenta/vrsta-komitenta-modal-update.component";
import { VrstaKomitenta } from "./vrsta-komitenta/vrsta-komitenta";
import { Tarifa } from "./tarifa/tarifa";
import { TarifaComponent } from "./tarifa/tarifa.component";
import { TarifaModalUpdateComponent } from "./tarifa/tarifa-modal-update.component";

import { PodVrsteDokumentaComponent } from './podvrste-dokumenta/podvrste-dokumenta.component';
import { PodVrsteDokumentaModalUpdateComponent } from './podvrste-dokumenta/podvrste-dokumenta-modal-update.component';
import { StopaComponent } from "./stopa/stopa.component";
import { Stopa } from "./stopa/stopa";
import { StopaModalUpdateComponent } from "./stopa/stopa-modal-update.component";
import { RobnaGrupaComponent } from "./robna-grupa/robna-grupa.component";
import { RobnaGrupa } from "./robna-grupa/robna-grupa";
import { RobnaGrupaModalUpdateComponent } from "./robna-grupa/robna-grupa-modal-update.component";
import { KomitentView } from './komitent/komitent-view';
import { OkrugView } from './okrug/okrug-view';


import { OpstinaView } from './opstina/opstina-view';

import { RobaView } from './roba/roba-view';

import { StopaView } from './stopa/stopa-view';

import { PodVrstaDokumentaView } from './podvrste-dokumenta/podvrste-dokumenta-view';
import { BankaComponent } from './banka/banka.component';
import { Banka } from './banka/banka';
import { BankaModalUpdateComponent } from './banka/banka-modal-update.component';
import { VrstaKontnogPlanaComponent } from './vrsta-kontnog-plana/vrsta-kontnog-plana.component';
import { VrstaKontnogPlana } from './vrsta-kontnog-plana/vrsta-kontnog-plana';
import { VrstaKontnogPlanaModalUpdateComponent } from './vrsta-kontnog-plana/vrsta-kontnog-plana-modal-update.component';
import { KontniPlanComponent } from './kontni-plan/kontni-plan.component';
import { KontniPlan } from './kontni-plan/kontni-plan';
import { KontniPlanView } from './kontni-plan/kontni-plan-view';
import { KontniPlanModalUpdateComponent } from './kontni-plan/kontni-plan-modal-update.component';
import { ValutaComponent } from './valuta/valuta.component';
import { Valuta } from './valuta/valuta';
import { ValutaModalUpdateComponent } from './valuta/valuta-modal-update.component';
import { PodVrstaDokumenta } from './podvrste-dokumenta/podvrste-dokumenta';
import { NacijaModalUpdateComponent } from './nacija/nacija-modal-update.component';
import { SvojinaComponent } from './svojina/svojina.component';
import { Svojina } from './svojina/svojina';
import { SvojinaModalUpdateComponent } from './svojina/svojina-modal-update.component';
import { BracniStatus } from './bracni-status/bracni-status';
import { BracniStatusComponent } from './bracni-status/bracni-status.component';
import { BracniStatusModalUpdateComponent } from './bracni-status/bracni-status-modal-update.component';
import { MesnaZajednicaComponent } from './mesna-zajednica/mesna-zajednica.component';
import { MesnaZajednica } from './mesna-zajednica/mesna-zajednica';
import { MesnaZajednicaView } from './mesna-zajednica/mesna-zajednica-view';
import { MesnaZajednicaModalUpdateComponent } from './mesna-zajednica/mesna-zajednica-modal-update.component';
import { NacijaComponent } from './nacija/nacija.component';
import { Nacija } from './nacija/nacija';
import { BankaView } from './banka/banka-view';
import { Osoba } from './osoba/osoba';
import { OsobaComponent } from './osoba/osoba.component';
import { OsobaModalUpdateComponent } from './osoba/osoba-modal-update.component';
import { KomitentEmail } from './komitent/komitent-email/komitent-email';
import { KomitentEmailView } from './komitent/komitent-email/komitent-email-view';
import { KomitentEmailModalUpdateComponent } from './komitent/komitent-email/komitent-email-modal-update.component';
import { KomitentTelefon } from './komitent/komitent-telefon/komitent-telefon';
import { KomitentTelefonView } from './komitent/komitent-telefon/komitent-telefon-view';
import { KomitentTelefonModalUpdateComponent } from './komitent/komitent-telefon/komitent-telefon-modal-update.component';
import { KomitentZrc } from './komitent/komitent-zrc/komitent-zrc';
import { KomitentZrcView } from './komitent/komitent-zrc/komitent-zrc-view';
import { KomitentZrcModalUpdateComponent } from './komitent/komitent-zrc/komitent-zrc-modal-update.component';
import { VrstaTelefonaComponent } from './vrsta-telefona/vrsta-telefona.component';
import { VrstaTelefona } from './vrsta-telefona/vrsta-telefona';
import { VrstaTelefonaModalUpdateComponent } from './vrsta-telefona/vrsta-telefona-modal-update.component';
import { PodVrsteDokumentaStavkaModalUpdateComponent } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-modal-update.component';
import { PodVrstaDokumentaStavkaView } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
import { PodvrsteDokumentaStavkaComponent } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka.component';
import { PodVrstaDokumentaStavka } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka';

import { Pol } from './pol/pol';
import { PolComponent } from './pol/pol.component';
import { PolModalUpdateComponent } from './pol/pol-modal-update.component';
import { NacinPlacanjaComponent } from './nacin-placanja/nacin-placanja.component';
import { NacinPlacanja } from './nacin-placanja/nacin-placanja';
import { Srodstvo } from './srodstvo/srodstvo';
import { SrodstvoComponent } from './srodstvo/srodstvo.component';
import { SrodstvoModalUpdateComponent } from './srodstvo/srodstvo-modal-update.component';
import { ZanimanjeComponent } from './zanimanje/zanimanje.component';
import { Zanimanje } from './zanimanje/zanimanje';
import { ZanimanjeModalUpdateComponent } from './zanimanje/zanimanje-modal-update.component';
import { VrstaDokumentaComponent } from './vrsta-dokumenta/vrsta-dokumenta.component';
import { VrstaDokumenta } from './vrsta-dokumenta/vrsta-dokumenta';
import { VrstaDokumentaModalUpdateComponent } from './vrsta-dokumenta/vrsta-dokumenta-modal-update.component';
import { TipRadneOpremeComponent } from './tip-radne-opreme/tip-radne-opreme.component';
import { TipRadneOpreme } from './tip-radne-opreme/tip-radne-opreme';
import { TipRadneOpremeModalUpdateComponent } from './tip-radne-opreme/tip-radne-opreme-modal-update.component';
import { TipRadneOpremeView } from './tip-radne-opreme/tip-radne-opreme-view';
import { VelicinaSetModalUpdateComponent } from './velicina/velicina-set-modal-update.component';
import { VelicinaSet } from './velicina/velicina-set';
import { VelicinaSetComponent } from './velicina/velicina-set.component';
import { VelicinaStav } from './velicina/velicina-stav';
import { VelicinaStavModalUpdateComponent } from './velicina/velicina-stav-modal-update.component';
import { OrgJedComponent } from './orgjed/orgjed.component';
import { OrgJed } from './orgjed/orgjed';
import { OrgJedModalUpdateComponent } from './orgjed/orgjed-modal-update.component';
import { OsobaRadnaOpremaUpdateComponent } from './osoba/osoba-radna-oprema/osoba-radna-oprema-update.component';
import { OsobaRadnaOpremaComponent } from './osoba/osoba-radna-oprema/osoba-radna-oprema.component';
import { OsobaRadnaOprema } from './osoba/osoba-radna-oprema/osoba-radna-oprema';
import { OsobaRadnaOpremaModalUpdateComponent } from './osoba/osoba-radna-oprema/osoba-radna-oprema-modal-update.component';
import { OsobaRadnaOpremaView } from './osoba/osoba-radna-oprema/osoba-radna-oprema-view';
import { KursDokumentStavkaModalUpdateComponent } from './kurs-valuta/kurs-dokument-stavka-modal-update.component';
import { KursDokumentView } from './kurs-valuta/kurs-dokument-view';
import { KursDokument } from './kurs-valuta/kurs-dokument';
import { KursDokumentTabsComponent } from './kurs-valuta/kurs-dokument-tabs.component';
import { KursDokumentStavkaView } from './kurs-valuta/kurs-dokument-stavka-view';
import { KursDokumentStavka } from './kurs-valuta/kurs-dokument-stavka';
import { OsobaSrodstvoUpdateComponent } from './osoba/osoba-srodstvo/osoba-srodstvo-update.component';
import { OsobaSrodstvo } from './osoba/osoba-srodstvo/osoba-srodstvo';
import { OsobaSrodstvoView } from './osoba/osoba-srodstvo/osoba-srodstvo-view';
import { OsobaSrodstvoModalUpdateComponent } from './osoba/osoba-srodstvo/osoba-srodstvo-modal-update.component';
import { OsobaSrodstvoComponent } from './osoba/osoba-srodstvo/osoba-srodstvo.component';
import { PageUpdateComponent } from './pageUpdateTest/page-update.component';
import { PageListComponent } from './pageUpdateTest/page-list.component';
import { CanActivateFalseGuard } from 'yt-ng-framework';
import { LookupsComponent } from './lookups.component';
import { ProizvodjacComponent } from './proizvodjac/proizvodjac.component';
import { Proizvodjac } from './proizvodjac/proizvodjac';
import { ProizvodjacModalUpdateComponent } from './proizvodjac/proizvodjac-modal-update.component';
import { GotovinskiKomitent } from './gotovinski-komitent/gotovinski-komitent';
import { GotovinskiKomitentModalUpdateComponent } from './gotovinski-komitent/gotovinski-komitent-modal-update.component';
import { GotovinskiKomitentComponent } from './gotovinski-komitent/gotovinski-komitent.component';
import { FirmaZrc } from './firma/firma-zrc';
import { FirmaZrcView } from './firma/firma-zrc-view';
import { KalendarNeradnihDanaComponent } from './kalendar-neradnih-dana/kalendar-neradnih-dana.component';
import { KalendarNeradnihDana } from './kalendar-neradnih-dana/kalendar-neradnih-dana';
import { KalendarNeradnihDanaUpdateComponent } from './kalendar-neradnih-dana/kalendar-neradnih-dana-update.component';
import { GotovinskiKomitentView } from './gotovinski-komitent/gotovinski-komitent-view';
import { KomitentObjekatComponent } from './komitent-objekat/komitent-objekat.component';
import { KomitentObjekat } from './komitent-objekat/komitent-objekat';
import { KomitentObjekatView } from './komitent-objekat/komitent-objekat-view';
import { KomitentObjekatModalUpdateComponent } from './komitent-objekat/komitent-objekat-modal-update.component';
import { KomitentTabsComponent } from './komitent/komitent-tabs.component';
import { PoreskoOslobodjenjeComponent } from './poresko-oslobodjenje/poresko-oslobodjenje.component';
import { PoreskoOslobodjenje } from './poresko-oslobodjenje/poresko-oslobodjenje';
import { PoreskoOslobodjenjeModalUpdateComponent } from './poresko-oslobodjenje/poresko-oslobodjenje-modal-update.component';

import { RadnoMesto } from './radno-mesto/radno-mesto';
import { RadnoMestoPosloviTabsComponent } from './radno-mesto/radno-mesto-poslovi-tabs.component';
import { RadnoMestoPoslovi } from './radno-mesto/radno-mesto-poslovi';
import { RadnoMestoPosloviView } from './radno-mesto/radno-mesto-poslovi-view.component';
import { RadnoMestoComponent } from './radno-mesto/radno-mesto.component';
import { RadnoMestoModalUpdateComponent } from './radno-mesto/radno-mesto-modal-update.component';
import { SpremaComponent } from './sprema/sprema.component';
import { Sprema } from './sprema/sprema';
import { SpremaModalUpdateComponent } from './sprema/sprema-modal-update.component';
import { Izvestaj } from './izvestaj/izvestaj';
import { PosaoComponent } from './posao/posao.component';
import { Posao } from './posao/posao';
import { PosaoModalUpdateComponent } from './posao/posao-modal-update.component';
import { VrstaIzostankaComponent } from './vrsta-izostanka/vrsta-izostanka.component';
import { VrstaIzostanka } from './vrsta-izostanka/vrsta-izostanka';
import { VrstaIzostankaModalUpdateComponent } from './vrsta-izostanka/vrsta-izostanka-modal-update.component';
import { KomitentObjekatUpisnoMestoComponent } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto.component';
import { KomitentObjekatUpisnoMesto } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto';
import { KomitentObjekatUpisnoMestoModalUpdateComponent } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto-modal-update.component';
import { KomitentObjekatUpisnoMestoView } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto-view';
import { KomitentUgovorTabsComponent } from './komitent-ugovor/komitent-ugovor-tabs.component';
import { KomitentUgovor } from './komitent-ugovor/komitent-ugovor';
import { KomitentUgovorView } from './komitent-ugovor/komitent-ugovor-view';
import { KomitentUgovorStavka } from './komitent-ugovor/komitent-ugovor-stavka';
import { KomitentUgovorStavkaView } from './komitent-ugovor/komitent-ugovor-stavka-view';
import { OsobaTabsComponent } from './osoba/osoba-tabs.component';
import { OsobaEmail } from './osoba/osoba-email/osoba-email';
import { OsobaEmailView } from './osoba/osoba-email/osoba-email-view';
import { OsobaEmailModalUpdateComponent } from './osoba/osoba-email/osoba-email-modal-update.component';
import { OsobaTelefon } from './osoba/osoba-telefon/osoba-telefon';
import { OsobaTelefonView } from './osoba/osoba-telefon/osoba-telefon-view';
import { OsobaTelefonModalUpdateComponent } from './osoba/osoba-telefon/osoba-telefon-modal-update.component';
import { KomitentKontaktOsoba } from './komitent-kontakt-osoba/komitent-kontakt-osoba';
import { KomitentKontaktOsobaView } from './komitent-kontakt-osoba/komitent-kontakt-osoba-view';
import { KomitentKontaktOsobaModalUpdateComponent } from './komitent-kontakt-osoba/komitent-kontakt-osoba-modal-update.component';
import { KomitentKontaktOsobaComponent } from './komitent-kontakt-osoba/komitent-kontakt-osoba.component';
import { LanguageComponent } from './language/language.component';
import { LanguageModalUpdateComponent } from './language/language-modal-update.component';
import { Language } from './language/Language';
import { VrstaVozilaComponent } from './vrsta-vozila/vrsta-vozila.component';
import { VrstaVozilaModalUpdateComponent } from './vrsta-vozila/vrsta-vozila-modal-update.component';
import { VrstaVozila } from './vrsta-vozila/vrsta-vozila';
import { VoziloComponent } from './vozilo/vozilo.component';
import { Vozilo } from './vozilo/vozilo';
import { VoziloView } from './vozilo/vozilo-view';
import { VoziloModalUpdateComponent } from './vozilo/vozilo-modal-update.component';
import { FirmaObjekatComponent } from '../admin/company/firma-objekat/firma-objekat.component';
import { FirmaObjekat } from '../admin/company/firma-objekat/firma-objekat';
import { FirmaObjekatView } from '../admin/company/firma-objekat/firma-objekat-view';
import { AkciznaRobaComponent } from './akcizna-roba/akcizna-roba.component';
import { AkciznaRoba } from './akcizna-roba/akcizna-roba';
import { AkciznaRobaView } from './akcizna-roba/akcizna-roba-view';
import { AkciznaRobaTipPakovanjaComponent } from './akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja.component';
import { AkciznaRobaTipPakovanja } from './akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja';
import { AkciznaRobaTipPakovanjaView } from './akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja-view';
import { KomitentVoziloComponent } from './komitent-vozilo/komitent-vozilo.component';
import { KomitentVoziloView } from './komitent-vozilo/komitent-vozilo-view';
import { KomitentVozilo } from './komitent-vozilo/komitent-vozilo';
import { KomitentVoziloModalUpdateComponent } from './komitent-vozilo/komitent-vozilo-modal-update.component';



export const LookupsRoutes: Routes = [
    {
        path: 'drzava',
        component: DrzavaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                printName: 'stampa_spiska_drzava',
                printType: PrintType.List,
                printController: 'Report',
                modelName: 'drzava',
                getName: 'get',
                getParameters: [],
                modelClass: Drzava,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'DRZAVA.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'ISOAlpha2Code', label: 'DRZAVA.ISOALPHA2CODE.SINGULAR', visible: true, canHide: false }
                    , { name: 'ISOAlpha3Code', label: 'DRZAVA.ISOALPHA3CODE.SINGULAR', visible: true, canHide: false }
                    , { name: 'ISONumericCode', label: 'DRZAVA.ISONUMERICCODE.SINGULAR', visible: true, canHide: false }


                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                //printName: 'printaj',
                defaultPropertyName: 'Naziv'
            },
            mainTitle: 'DRZAVA',
            updateComponent: DrzavaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'DRZAVA.PLURAL'
        }
    }

    , {
        path: 'posao',
        component: PosaoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'posao',
                getName: 'get',
                getParameters: [],
                modelClass: Posao,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'POSLOVI.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'Opis', label: 'POSLOVI.OPIS.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,

            },
            mainTitle: 'POSAO',
            updateComponent: PosaoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'POSLOVI.PLURAL'
        }
    }


    , {
        path: 'FirmaZrc',
        component: DrzavaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'FirmaZrc',
                getName: 'GetForCurrentCompany',
                modelClass: FirmaZrc,
                shortModelClass: FirmaZrcView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Zrc', label: 'Račun', visible: true, canHide: false }
                ],
                formType: 'reactive'
            }
        }
    }

    , {
        path: 'roba',
        component: RobaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'roba',
                getName: 'get',
                getParameters: [],
                modelClass: Roba,
                shortModelClass: RobaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'ROBA.SIFRA.SINGULAR', visible: true, canHide: true, width: '100px' }
                    , { name: 'Barcode', label: 'ROBA.BARCODE.SINGULAR', visible: true, canHide: true }
                    , { name: 'Naziv', label: 'ROBA.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'UnitOfMeasure', label: 'ROBA.UNITOFMEASUREID.SINGULAR', visible: true, canHide: true }
                    , { name: 'RobnaGrupa', label: 'ROBA.ROBNAGRUPAID.SINGULAR', visible: true, canHide: true }

                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Roba',
            updateComponent: RobaModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ROBA.SINGULAR'
        }
    },
    {
        path: 'jedinicamere',
        component: JedinicaMereComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'jedinicamere',
                getName: 'get',
                getParameters: [],
                modelClass: JedinicaMere,
                parentProperty: '',
                tableColumns: [
                    { name: 'Oznaka', label: 'JEDINICAMERE.OZNAKA.SINGULAR', visible: true, canHide: false },
                    { name: 'Naziv', label: 'JEDINICAMERE.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'JediniceMere',
            updateComponent: JedinicaMereModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'JEDINICAMERE.PLURAL'
        }
    },
    {
        path: 'komitent',
        // component: KomitentComponent,
        component: KomitentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                label: 'TABLE.KOMITENTI.PLURAL',
                modelName: 'komitent',
                getName: 'get',
                getParameters: [],
                modelClass: Komitent,
                shortModelClass: KomitentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'SNaziv', label: 'KOMITENT.SNAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'PibJmbg', label: 'KOMITENT.PIBJMBG.SINGULAR', visible: true, canHide: false },
                    { name: 'Adresa', label: 'KOMITENT.ADRESA.SINGULAR', visible: true, canHide: false },
                    { name: 'Mesto', label: 'KOMITENT.MESTO.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'SNaziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.KOMITENTISTAVKE.PLURAL',
                        modelName: 'KomitentEmail',
                        getName: 'getByKomitentID',
                        getParameters: [],
                        modelClass: KomitentEmail,
                        shortModelClass: KomitentEmailView,
                        tableColumns: [
                            { name: 'Opis', label: 'KOMITENTEMAIL.OPIS.SINGULAR', visible: true }
                            , { name: 'Email', label: 'KOMITENTEMAIL.NAZIV.SINGULAR', visible: true }
                            , { name: 'Glavni', label: 'KOMITENTEMAIL.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '5%' }
                            , { name: 'Svojina', label: 'KOMITENTEMAIL.SVOJINA.SINGULAR', visible: true }
                            , { name: 'ZaSef', label: 'KOMITENTEMAIL.ZASEF.SINGULAR', visible: true, type: ColumnType.Boolean, width: '5%' }
                        ],
                        sortBy: 'Email',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KomitentID',
                        updateComponent: KomitentEmailModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: false,
                        refreshType: RefreshType.Reload
                    }
                    , {
                        modelName: 'KomitentTelefon',
                        getName: 'getByKomitentID',
                        getParameters: [],
                        modelClass: KomitentTelefon,
                        shortModelClass: KomitentTelefonView,
                        tableColumns: [
                            { name: 'Opis', label: 'KOMITENTTELEFON.OPIS.SINGULAR', visible: true }
                            , { name: 'Broj', label: 'KOMITENTTELEFON.BROJ.SINGULAR', visible: true }
                            , { name: 'VrstaTelefona', label: 'KOMITENTTELEFON.VRSTATELEFONA.SINGULAR', visible: true }
                            , { name: 'Glavni', label: 'KOMITENTTELEFON.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '5%' }
                            , { name: 'Lokal', label: 'KOMITENTTELEFON.LOKAL.SINGULAR', visible: true }
                            , { name: 'Svojina', label: 'KOMITENTTELEFON.SVOJINA.SINGULAR', visible: true }
                        ],
                        sortBy: 'Broj',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KomitentID',
                        updateComponent: KomitentTelefonModalUpdateComponent,
                        formType: 'reactive',
                        refreshType: RefreshType.Reload
                    }
                    , {
                        modelName: 'KomitentZrc',
                        getName: 'getByKomitentID',
                        getParameters: [],
                        modelClass: KomitentZrc,
                        shortModelClass: KomitentZrcView,
                        tableColumns: [
                            { name: 'Zrc', label: 'KOMITENTZRC.ZRC.SINGULAR', visible: true, aligment: 'left', width: '30%' }
                            , { name: 'Glavni', label: 'KOMITENTZRC.GLAVNI.SINGULAR', visible: true, aligment: 'center', type: ColumnType.Boolean, width: '10%' }
                            , { name: 'Devizni', label: 'KOMITENTZRC.DEVIZNI.SINGULAR', visible: true, aligment: 'center', type: ColumnType.Boolean, width: '10%' }
                            , { name: 'Banka', label: 'KOMITENTZRC.BANKA.SINGULAR', visible: true, aligment: 'left', width: '40%' }
                            , { name: 'IsActive', label: 'KOMITENTZRC.ISACTIVE.SINGULAR', visible: true, aligment: 'center', type: ColumnType.Boolean, width: '10%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KomitentID',
                        updateComponent: KomitentZrcModalUpdateComponent,
                        formType: 'reactive',
                        refreshType: RefreshType.Reload
                    }
                    , {
                        modelName: 'komitentobjekat',
                        getName: 'getByKomitentID',
                        getParameters: [],
                        modelClass: KomitentObjekat,
                        shortModelClass: KomitentObjekatView,
                        tableColumns: [
                            { name: 'NazivObjekta', label: 'KOMITENTOBJEKAT.NAZIVOBJEKTA.SINGULAR', visible: true, canHide: false }
                            , { name: 'KomitentNaziv', label: 'KOMITENTOBJEKAT.KOMITENT.SINGULAR', visible: true, canHide: false }
                            , { name: 'MestoNaziv', label: 'KOMITENTOBJEKAT.MESTO.SINGULAR', visible: true, canHide: false }
                        ],
                        sortBy: 'Naziv',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KomitentID',
                        updateComponent: KomitentObjekatModalUpdateComponent,
                        formType: 'reactive'
                    }
                    , {
                        modelName: 'komitentkontaktosoba',
                        getName: 'getByKomitentID',
                        getParameters: [],
                        modelClass: KomitentKontaktOsoba,
                        shortModelClass: KomitentKontaktOsobaView,
                        tableColumns: [
                            { name: 'OsobaNaziv', label: 'KOMITENTKONTAKTOSOBA.OSOBA.SINGULAR', visible: true, canHide: false }
                            , { name: 'KomitentNaziv', label: 'KOMITENTKONTAKTOSOBA.KOMITENT.SINGULAR', visible: true, canHide: false }
                            , { name: 'Opis', label: 'KOMITENTKONTAKTOSOBA.OPIS.SINGULAR', visible: true, canHide: false }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KomitentID',
                        updateComponent: KomitentKontaktOsobaModalUpdateComponent,
                        formType: 'reactive'
                    }
                ]
            },
            mainTitle: 'Komitenti',
            updateComponent: KomitentModalUpdateComponent,
            modalSize: ModalSize.Xl,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KOMITENT.PLURAL'
        }
    },
    {
        path: 'magacin',
        component: MagacinComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'magacin',
                getName: 'get',
                getParameters: [],
                modelClass: Magacin,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'MAGACIN.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'SNaziv', label: 'MAGACIN.SNAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Magacini',
            updateComponent: MagacinModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'MAGACIN.PLURAL'
        }
    },
    {
        path: 'mesto',
        component: MestoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                printController: 'Report',
                printName: 'StampaSpiskaMesta',
                printType: PrintType.List,
                modelName: 'mesto',
                getName: 'get',
                getParameters: [],
                modelClass: Mesto,
                shortModelClass: MestoView,
                parentProperty: '',
                tableColumns: [
                    { name: 'PostBroj', label: 'MESTO.POSTBROJ.SINGULAR', visible: true, canHide: false },
                    { name: 'Naziv', label: 'MESTO.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Opstina', label: 'MESTO.OPSTINAID.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Mesta',
            updateComponent: MestoModalUpdateComponent,
            modalSize: ModalSize.Xl,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'MESTO.PLURAL'
        }
    },
    {
        path: 'okrug',
        component: OkrugComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'okrug',
                getName: 'get',
                getParameters: [],
                modelClass: Okrug,
                shortModelClass: OkrugView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'OKRUG.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Drzava', label: 'OKRUG.DRZAVAID.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Okrug',
            updateComponent: OkrugModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OKRUG.PLURAL'
        }
    },
    {
        path: 'opstina',
        component: OpstinaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'opstina',
                getName: 'get',
                getParameters: [],
                modelClass: Opstina,
                shortModelClass: OpstinaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'OPSTINA.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Okrug', label: 'OPSTINA.OKRUGID.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Opstina',
            updateComponent: OpstinaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OPSTINA.PLURAL'
        }
    }
    , {
        path: 'tipkomitenta',
        component: TipKomitentaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'tipkomitenta',
                getName: 'get',
                getParameters: [],
                modelClass: TipKomitenta,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'TIPKOMITENTA.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'GenericName', label: 'TIPKOMITENTA.GENERICNAME.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'TipKomitenta',
            updateComponent: TipKomitentaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'TIPKOMITENTA.PLURAL'
        }
    }
    , {
        path: 'vrstakomitenta',
        component: VrstaKomitentaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'vrstakomitenta',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaKomitenta,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTAKOMITENTA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,

                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Vrsta Komitenta',
            updateComponent: VrstaKomitentaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTAKOMITENTA.PLURAL'
        }
    }
    , {
        path: 'tarifa',
        component: TarifaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'tarifa',
                getName: 'getFlat',
                getParameters: [],
                modelClass: Tarifa,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'TARIFA.SIFRA.SINGULAR', visible: true, canHide: false }
                    , { name: 'Naziv', label: 'TARIFA.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'AktuelnaStopa', label: 'TARIFA.AKTUELNASTOPA.SINGULAR', visible: true, canHide: true, type: ColumnType.Number, format: '1.0-0' }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Tarifa',
            updateComponent: TarifaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'TARIFA.PLURAL'
        }
    }
    , {
        path: 'podvrstadokumenta',
        component: PodVrsteDokumentaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'podvrstadokumenta',
                getName: 'get',
                getParameters: [],
                modelClass: PodVrstaDokumenta,
                shortModelClass: PodVrstaDokumentaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'VrstaDokumenta', label: 'PODVRSTADOKUMENTA.VRSTADOKUMENTAID.SINGULAR', visible: true, canHide: false, width: '35%' },
                    { name: 'Naziv', label: 'PODVRSTADOKUMENTA.NAZIV.SINGULAR', visible: true, canHide: false, width: '35%' },
                    { name: 'SNaziv', label: 'PODVRSTADOKUMENTA.SNAZIV.SINGULAR', visible: true, canHide: false, width: '10%' },
                    { name: 'GenericName', label: 'PODVRSTADOKUMENTA.GENERICNAME.SINGULAR', visible: true, canHide: false, width: '10%' },
                    { name: 'IsActive', label: 'PODVRSTADOKUMENTA.AKTIVAN.SINGULAR', visible: true, canHide: false, type: ColumnType.Boolean, width: '10%' }

                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'PodVrsteDokumenta',
            updateComponent: PodVrsteDokumentaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'PODVRSTADOKUMENTA.PLURAL'
        }
    }
    , {
        path: 'stopa',
        component: StopaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'stopa',
                getName: 'get',
                getParameters: [],
                modelClass: Stopa,
                shortModelClass: StopaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Tarifa', label: 'STOPA.TARIFAID.SINGULAR', visible: true, canHide: false }
                    , { name: 'Datum', label: 'STOPA.DATUM.SINGULAR', visible: true, canHide: true, type: ColumnType.Date }
                    , { name: 'Iznos', label: 'STOPA.IZNOS.SINGULAR', visible: true, canHide: false, type: ColumnType.Number }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Stopa',
            updateComponent: StopaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'STOPA.PLURAL'
        }
    }
    , {
        path: 'robnagrupa',
        component: RobnaGrupaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'robnagrupa',
                getName: 'getRoot',
                getParameters: [],
                modelClass: RobnaGrupa,
                shortModelClass: RobnaGrupa,
                parentProperty: '',
                tableColumns: [
                    // { name: 'Sifra', label: 'ROBNAGRUPA.SIFRA.SINGULAR', visible: true, canHide: false},
                    { name: 'Naziv', label: 'ROBNAGRUPA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultListType: DefaultListType.Treeview
            },
            mainTitle: 'Robna grupa',
            updateComponent: RobnaGrupaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'ROBNAGRUPA.PLURAL'
        }
    }
    , {
        path: 'banka',
        component: BankaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'banka',
                getName: 'get',
                getParameters: [],
                modelClass: Banka,
                shortModelClass: BankaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'BANKA.SIFRA.SINGULAR', visible: true, canHide: false }
                    , { name: 'Naziv', label: 'BANKA.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'Adresa', label: 'BANKA.ADRESA.SINGULAR', visible: true, canHide: true }
                    , { name: 'Mesto', label: 'BANKA.MESTO.SINGULAR', visible: true, canHide: true }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Banka',
            updateComponent: BankaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'BANKA.PLURAL'
        }
    }
    , {
        path: 'vrstakontnogplana',
        component: VrstaKontnogPlanaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'vrstakontnogplana',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaKontnogPlana,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTAKONTNOGPLANA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Vrsta kontnog plana',
            updateComponent: VrstaKontnogPlanaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTAKONTNOGPLANA.PLURAL'
        }
    }
    , {
        path: 'kontniplan',
        component: KontniPlanComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'kontniplan',
                getName: 'get',
                getParameters: [],
                modelClass: KontniPlan,
                shortModelClass: KontniPlanView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Konto', label: 'KONTNIPLAN.KONTO.SINGULAR', visible: true, canHide: false },
                    { name: 'Naziv', label: 'KONTNIPLAN.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'ImaAna', label: 'KONTNIPLAN.IMAANA.SINGULAR', visible: true, canHide: false, type: ColumnType.Boolean },
                    { name: 'VrstaKontnogPlana', label: 'KONTNIPLAN.VRSTAKONTNOGPLANAID.SINGULAR', visible: true, canHide: false },

                ],
                sortBy: 'Konto',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Kontni plan',
            updateComponent: KontniPlanModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KONTNIPLAN.SINGULAR'
        }
    }
    , {
        path: 'valuta',
        component: ValutaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'valuta',
                getName: 'get',
                getParameters: [],
                modelClass: Valuta,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'VALUTA.SIFRANUMERIC.SINGULAR', visible: true, canHide: false },
                    { name: 'ISOAlpha3Code', label: 'VALUTA.ISOALPHA3CODE.SINGULAR', visible: true, canHide: false },
                    { name: 'Naziv', label: 'VALUTA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Valuta',
            updateComponent: ValutaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VALUTA.PLURAL'
        }
    }
    , {
        path: 'vrstaizostanka',
        component: VrstaIzostankaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                userRightsModelName: 'vrstaizostanka',
                modelName: 'vrstaizostanka',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaIzostanka,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTAIZOSTANKA.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Oznaka', label: 'VRSTAIZOSTANKA.OZNAKA.SINGULAR', visible: true, canHide: false },
                    { name: 'Sati', label: 'VRSTAIZOSTANKA.SATI.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'VrstaIzostanka',
            updateComponent: VrstaIzostankaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTAIZOSTANKA.PLURAL'
        }
    }
    , {
        path: 'nacija',
        component: NacijaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'nacija',
                getName: 'get',
                getParameters: [],
                modelClass: Nacija,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'NACIJA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Nacija',
            updateComponent: NacijaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'NACIJA.PLURAL'
        }
    }
    , {
        path: 'pol',
        component: PolComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'pol',
                getName: 'get',
                getParameters: [],
                modelClass: Pol,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'POL.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Pol',
            updateComponent: PolModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'POL.PLURAL'
        }
    }
    , {
        path: 'bracnistatus',
        component: BracniStatusComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'BracniStatus',
                userRightsModelName: 'bracnistatus',
                getName: 'get',
                getParameters: [],
                modelClass: BracniStatus,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'BRACNISTATUS.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Bračni status',
            updateComponent: BracniStatusModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'BRACNISTATUS.PLURAL'
        }
    }
    , {
        path: 'svojina',
        component: SvojinaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'svojina',
                getName: 'get',
                getParameters: [],
                modelClass: Svojina,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'SVOJINA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Svojina',
            updateComponent: SvojinaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'SVOJINA.PLURAL'
        }
    },
    {
        path: 'mz',
        component: MesnaZajednicaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'mz',
                userRightsModelName: 'mesnazajednica',
                getName: 'get',
                getParameters: [],
                modelClass: MesnaZajednica,
                shortModelClass: MesnaZajednicaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'MESNAZAJEDNICA.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Mesto', label: 'MESNAZAJEDNICA.MESTOID.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',

                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Mesna zajednica',
            updateComponent: MesnaZajednicaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'MESNAZAJEDNICA.PLURAL'
        }
    }
    , {
        path: 'osoba',
        // component: OsobaComponent,
        component: OsobaTabsComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.OSOBE.PLURAL',
                modelName: 'osoba',
                getName: 'get',
                getParameters: [],
                modelClass: Osoba,
                parentProperty: '',
                tableColumns: [
                    { name: 'Prezime', label: 'OSOBA.PREZIME.SINGULAR', visible: true }
                    , { name: 'Ime', label: 'OSOBA.IME.SINGULAR', visible: true }
                    , { name: 'Jmbg', label: 'OSOBA.JMBG.SINGULAR', visible: true }
                ],
                sortBy: 'Prezime',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                detailList: [
                    {
                        label: 'TABLE.OSOBESTAVKE.PLURAL',
                        modelName: 'OsobaEmail',
                        getName: 'getByOsobaID',
                        getParameters: [],
                        modelClass: OsobaEmail,
                        shortModelClass: OsobaEmailView,
                        tableColumns: [
                            { name: 'Email', label: 'OSOBAEMAIL.NAZIV.SINGULAR', visible: true }
                            , { name: 'Glavni', label: 'OSOBAEMAIL.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '5%' }
                            , { name: 'Svojina', label: 'OSOBAEMAIL.SVOJINA.SINGULAR', visible: true }
                        ],
                        sortBy: 'Email',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'OsobaID',
                        updateComponent: OsobaEmailModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: false,
                        refreshType: RefreshType.Reload,
                    }
                    , {
                        modelName: 'OsobaTelefon',
                        getName: 'getByOsobaID',
                        getParameters: [],
                        modelClass: OsobaTelefon,
                        shortModelClass: OsobaTelefonView,
                        tableColumns: [
                            { name: 'Broj', label: 'OSOBATELEFON.BROJ.SINGULAR', visible: true }
                            , { name: 'VrstaTelefona', label: 'OSOBATELEFON.VRSTATELEFONA.SINGULAR', visible: true }
                            , { name: 'Glavni', label: 'OSOBATELEFON.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean, width: '5%' }
                            , { name: 'Lokal', label: 'OSOBATELEFON.LOKAL.SINGULAR', visible: true }
                            , { name: 'Svojina', label: 'OSOBATELEFON.SVOJINA.SINGULAR', visible: true }
                        ],
                        sortBy: 'Broj',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'OsobaID',
                        updateComponent: OsobaTelefonModalUpdateComponent,
                        formType: 'reactive',
                        refreshType: RefreshType.Reload,
                    }
                ]
            },
            mainTitle: 'Osoba',
            updateComponent: OsobaModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OSOBA.PLURAL'
        }
    }
    , {
        path: 'vrstatelefona',
        component: VrstaTelefonaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'vrstatelefona',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaTelefona,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTATELEFONA.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Vrsta telefona',
            updateComponent: VrstaTelefonaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTATELEFONA.PLURAL'
        }
    }
    , {
        path: 'orgjed',
        component: OrgJedComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'orgjed',
                getName: 'getRoot',
                getParameters: [],
                modelClass: OrgJed,
                shortModelClass: OrgJed,
                parentProperty: '',
                tableColumns: [
                    // { name: 'Sifra', label: 'ORGJED.SIFRA.SINGULAR', visible: true, canHide: false}
                    { name: 'Naziv', label: 'ORGJED.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultListType: DefaultListType.Treeview
            },
            mainTitle: 'Organizaciona jedinica',
            updateComponent: OrgJedModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'ORGJED.PLURAL'
        }
    }
    , {
        path: 'podvrstadokumentastavka',
        component: PodvrsteDokumentaStavkaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.PODVRSTEDOKUMENATA.PLURAL',
                modelName: 'podvrstadokumentastavka',
                getName: 'get',
                getParameters: [],
                modelClass: PodVrstaDokumentaStavka,
                shortModelClass: PodVrstaDokumentaStavkaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'PodVrstaDokumenta', label: 'PODVRSTADOKUMENTASTAVKA.PODVRSTADOKUMENTA.SINGULAR', visible: true, canHide: false },
                    { name: 'Naziv', label: 'PODVRSTADOKUMENTASTAVKA.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'Sifra', label: 'PODVRSTADOKUMENTASTAVKA.SIFRA.SINGULAR', visible: true, canHide: false },
                    { name: 'Aktivan', label: 'PODVRSTADOKUMENTASTAVKA.AKTIVAN.SINGULAR', visible: true, canHide: false, type: ColumnType.Boolean }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'PodVrstaDokumentaStavka',
            updateComponent: PodVrsteDokumentaStavkaModalUpdateComponent,
            modalSize: 'xl',
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'PODVRSTADOKUMENTASTAVKA.PLURAL'
        }
    }
    , {
        path: 'nacinplacanja',
        component: NacinPlacanjaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'nacinplacanja',
                getName: 'get',
                getParameters: [],
                modelClass: NacinPlacanja,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'NACINPLACANJA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'NacinPlacanja',
            updateComponent: NacinPlacanjaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'NACINPLACANJA.PLURAL'
        }
    }
    , {
        path: 'osobasrodstvo',
        component: OsobaSrodstvoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'OsobaSrodstvo',
                getName: 'get',
                getParameters: [],
                modelClass: OsobaSrodstvo,
                shortModelClass: OsobaSrodstvoView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Zaposleni', label: 'OSOBASRODSTVO.ZAPOSLENI.SINGULAR', visible: true },
                    { name: 'Srodstvo', label: 'OSOBASRODSTVO.SRODSTVO.SINGULAR', visible: true },
                    { name: 'SrodOsoba', label: 'OSOBASRODSTVO.SRODOSOBA.SINGULAR', visible: true }
                ],
                sortBy: 'Osoba',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'OsobaSrodstvo',
            updateComponent: OsobaSrodstvoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OSOBASRODSTVO.PLURAL'
        }
    }
    , {
        path: 'osobaradnaoprema',
        component: OsobaRadnaOpremaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'OsobaRadnaOprema',
                getName: 'get',
                getParameters: [],
                modelClass: OsobaRadnaOprema,
                shortModelClass: OsobaRadnaOpremaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'TipRadneOpreme', label: 'OSOBARADNAOPREMA.TIPRADNEOPREME.SINGULAR', visible: true },
                    { name: 'VelicinaStav', label: 'OSOBARADNAOPREMA.VELICINA.SINGULAR', visible: true },
                    { name: 'Osoba', label: 'OSOBARADNAOPREMA.OSOBA.SINGULAR', visible: true }
                ],
                sortBy: 'TipRadneOpreme',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'OsobaRadnaOprema',
            updateComponent: OsobaRadnaOpremaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OSOBARADNAOPREMA.PLURAL'
        }
    }
    , {
        path: 'srodstvo',
        component: SrodstvoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'srodstvo',
                getName: 'get',
                getParameters: [],
                modelClass: Srodstvo,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'SRODSTVO.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Srodstvo',
            updateComponent: SrodstvoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'SRODSTVO.PLURAL'
        }
    }
    , {
        path: 'zanimanje',
        component: ZanimanjeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'zanimanje',
                getName: 'get',
                getParameters: [],
                modelClass: Zanimanje,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'ZANIMANJE.SIFRA.SINGULAR', visible: true }
                    , { name: 'Naziv', label: 'ZANIMANJE.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultListButtonsOptions: { showDefaultListButtons: true }
            },
            mainTitle: 'Zanimanje',
            updateComponent: ZanimanjeModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ZANIMANJE.PLURAL'
        }
    }
    , {
        path: 'vrstadokumenta',
        component: VrstaDokumentaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'vrstadokumenta',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaDokumenta,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTADOKUMENTASTAVKA.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'GenericName', label: 'VRSTADOKUMENTASTAVKA.GENERICNAME.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'VrstaDokumenta',
            updateComponent: VrstaDokumentaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTADOKUMENTA.PLURAL'
        }
    }
    , {
        path: 'tipradneopreme',
        component: TipRadneOpremeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                shortModelClass: TipRadneOpremeView,
                modelName: 'tipradneopreme',
                userRightsModelName: 'tipradneopreme',
                getName: 'get',
                getParameters: [],
                modelClass: TipRadneOpreme,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'TIPRADNEOPREME.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'VelicinaSet', label: 'TIPRADNEOPREME.VELICINASET.SINGULAR', visible: true, canHide: false }

                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Tip radne opreme',
            updateComponent: TipRadneOpremeModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'TIPRADNEOPREME.PLURAL'
        }
    }
    , {
        path: 'velicinaset',
        component: VelicinaSetComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'velicinaset',
                userRightsModelName: 'velicinaset',
                getName: 'get',
                getParameters: [],
                modelClass: VelicinaSet,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VELICINASET.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive

                , detailList: [
                    {
                        modelName: 'VelicinaStav',
                        getName: 'getByVelicinaSetID',
                        getParameters: [],
                        modelClass: VelicinaStav,
                        tableColumns: [
                            { name: 'Naziv', label: 'VELICINASTAV.NAZIV.SINGULAR' }
                        ],
                        sortBy: 'RedniBroj',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'VelicinaSetID',
                        updateComponent: VelicinaStavModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ]


            },
            mainTitle: 'Veličine',
            updateComponent: VelicinaSetModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VELICINASET.PLURAL'
        }
    }
    , {
        path: 'velicinastav',
        component: VelicinaSetComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'velicinastav',
                getName: 'get',
                getParameters: [],
                modelClass: VelicinaStav,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VELICINASTAV.NAZIV.SINGULAR', visible: true, canHide: false }
                ]
            },
            mainTitle: 'Veličine'
        }
    }
    , {
        path: 'kurs-valuta',
        component: KursDokumentTabsComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'printaj',
                modelName: 'KursDokument',
                userRightsModelName: 'kursvaluta',
                getName: 'get',
                getParameters: [],
                modelClass: KursDokument,
                shortModelClass: KursDokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'KURSDOKUMENT.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '40%' }
                    , { name: 'Opis', label: 'KURSDOKUMENT.OPIS.SINGULAR', visible: true, canHide: false, width: '60%' }
                ],
                sortBy: 'Datum',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        modelName: 'KursDokumentStavka',
                        getName: 'getByKursDokumentID',
                        getParameters: [],
                        modelClass: KursDokumentStavka,
                        shortModelClass: KursDokumentStavkaView,
                        tableColumns: [
                            { name: 'Valuta', label: 'KURSDOKUMENTSTAVKA.VALUTA.SINGULAR', visible: true, width: '40%' }
                            , { name: 'VredDinK', label: 'KURSDOKUMENTSTAVKA.KUPOVNI.SINGULAR', type: 'number', aligment: 'right', format: '1.2-2', visible: true }
                            , { name: 'VredDinS', label: 'KURSDOKUMENTSTAVKA.SREDNJI.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                            , { name: 'VredDinP', label: 'KURSDOKUMENTSTAVKA.PRODAJNI.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }

                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KursDokumentID',
                        updateComponent: KursDokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ]
            },
            mainTitle: 'Kurs valuta',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KURSDOKUMENT.PLURAL'
        }
    }
    , {
        path: 'kalendar-neradnih-dana1',
        component: KalendarNeradnihDanaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'kalendarneradnihdana',
                getName: 'get',
                getParameters: [],
                modelClass: KalendarNeradnihDana,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'KALENDARNERADNIHDANA.DATUM.SINGULAR', visible: true, canHide: false, type: ColumnType.Date },
                    { name: 'Opis', label: 'KALENDARNERADNIHDANA.OPIS.SINGULAR', visible: true, canHide: false }

                ],
                sortBy: 'Datum',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Kalendar neradnih dana',
            updateComponent: KalendarNeradnihDanaUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KALENDARNERADNIHDANA.PLURAL'
        }
    }
    , {
        path: 'page-list',
        component: PageListComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'drzava',
                getName: 'get',
                getParameters: [],
                modelClass: Drzava,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'DRZAVA.NAZIV.SINGULAR' }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Naziv'
            },
            mainTitle: 'Drzava',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'DRZAVA.SINGULAR'
        }
    },
    {
        path: 'page-list/:id',
        component: PageUpdateComponent,
        data: {
            mainList: {
                modelName: 'drzava',
                getName: 'get',
                getParameters: [],
                modelClass: Drzava,
                parentProperty: '',
                tableColumns: [
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: 'Naziv'
            },
            mainTitle: 'Drzava',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcumbLabel: 'DRZAVA.SINGULAR'
        }
    },
    {
        path: 'commonString',
        component: LookupsComponent,
        canActivate: [CanActivateFalseGuard],
        data: {
            mainList: {
                modelName: 'CommonString',
                tableColumns: [
                    { name: 'Name', label: 'Naziv', visible: true },
                    { name: 'ID', label: 'ID', visible: false }
                ]
            }
        }
    }
    , {
        path: 'proizvodjac',
        component: ProizvodjacComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'proizvodjac',
                getName: 'getRoot',
                getParameters: [],
                modelClass: Proizvodjac,
                shortModelClass: Proizvodjac,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'PROIZVODJAC.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                defaultListType: DefaultListType.Treeview
            },
            mainTitle: 'Proizvođač',
            updateComponent: ProizvodjacModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'PROIZVODJAC.PLURAL'
        }
    }
    , {
        path: 'gotovinskikupac',
        component: GotovinskiKomitentComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'gotovinskikomitent',
                userRightsModelName: 'gotovinskikupac',
                getName: 'get',
                getParameters: [],
                modelClass: GotovinskiKomitent,
                shortModelClass: GotovinskiKomitentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'GOTOVINSKIKOMITENT.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'Pib', label: 'GOTOVINSKIKOMITENT.PIB.SINGULAR', visible: true, canHide: false }
                    , { name: 'MatBr', label: 'GOTOVINSKIKOMITENT.MATBR.SINGULAR', visible: true, canHide: false }
                    , { name: 'MestoNaziv', label: 'GOTOVINSKIKOMITENT.MESTO.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Gotovinski kupac',
            updateComponent: GotovinskiKomitentModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'GOTOVINSKIKOMITENT.PLURAL'
        }
    }
    , {
        path: 'komitentobjekat',
        component: KomitentObjekatComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.KOMITENTOBJEKAT.PLURAL',
                modelName: 'komitentobjekat',
                userRightsModelName: 'komitentobjekat',
                getName: 'get',
                getParameters: [],
                modelClass: KomitentObjekat,
                shortModelClass: KomitentObjekatView,
                parentProperty: 'KomitentID',
                tableColumns: [
                    { name: 'NazivObjekta', label: 'KOMITENTOBJEKAT.NAZIVOBJEKTA.SINGULAR', visible: true, canHide: false }
                    , { name: 'KomitentNaziv', label: 'KOMITENTOBJEKAT.KOMITENT.SINGULAR', visible: true, canHide: false }
                    , { name: 'MestoNaziv', label: 'KOMITENTOBJEKAT.MESTO.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Komitent objekat',
            updateComponent: KomitentObjekatModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KOMITENTOBJEKAT.PLURAL'
        }
    },
    {
        path: 'komitentugovor',
        component: KomitentUgovorTabsComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'komitentugovor',
                getName: 'getByOrgJedID',
                getParameters: [{ Name: 'url', Value: '/lookups/komitentugovor' }],
                modelClass: KomitentUgovor,
                shortModelClass: KomitentUgovorView,
                tableColumns: [
                    { name: 'KomitentNaziv', label: 'KOMITENTUGOVOR.KOMITENT.SINGULAR', visible: true, canHide: false, width: '40%' },
                    // { name: 'BrojDokumenta', label: 'KOMITENTUGOVOR.BROJDOKUMENTA.SINGULAR', visible: true, canHide: false, width: '20%' },
                    { name: 'BrojDokumenta2', label: 'KOMITENTUGOVOR.BROJDOKUMENTA.SINGULAR', visible: true, canHide: false, width: '20%' },
                    { name: 'OdDatuma', label: 'KOMITENTUGOVOR.ODDATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' },
                    { name: 'DoDatuma', label: 'KOMITENTUGOVOR.DODATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
                ],
                sortBy: 'Datum',
                sortReverse: false,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        modelName: 'KomitentUgovorStavka',
                        getName: 'getByKomitentUgovorID',
                        getParameters: [],
                        modelClass: KomitentUgovorStavka,
                        shortModelClass: KomitentUgovorStavkaView,
                        tableColumns: [
                            { name: 'UgovorenaKolicina', label: 'KOMITENTUGOVORSTAVKA.KOLICINA.SINGULAR', visible: true, width: '20%' },
                            { name: 'UgovorenaJedinicaMere', label: 'KOMITENTUGOVORSTAVKA.JEDINICAMERE.SINGULAR', visible: true, width: '20%' },
                            { name: 'UgovorenaVrednost', label: 'KOMITENTUGOVORSTAVKA.UGOVORENAVREDNOST.SINGULAR', visible: true, width: '20%' },
                            { name: 'ValutaUgovorenaVrednost', label: 'KOMITENTUGOVORSTAVKA.UGOVORENAVREDNOSTVALUTA.SINGULAR', visible: true, width: '20%' }


                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'KomitentUgovorID',
                        updateComponent: '',
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ]
            },
            mainTitle: 'Komitent ugovor',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KOMITENTUGOVOR.PLURAL'
        }
    }
    , {
        path: 'poreskooslobodjenje',
        component: PoreskoOslobodjenjeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'poreskooslobodjenje',
                userRightsModelName: 'poreskooslobodjenje',
                getName: 'get',
                getParameters: [],
                modelClass: PoreskoOslobodjenje,
                tableColumns: [
                    { name: 'Key', label: 'PORESKOOSLOBODJENJE.KEY.SINGULAR', visible: true, canHide: false, width: "25%" }
                    , { name: 'Naziv', label: 'PORESKOOSLOBODJENJE.NAZIV.SINGULAR', visible: true, canHide: false, width: "65%", aligment: 'Justify' }
                    , { name: 'Category', label: 'PORESKOOSLOBODJENJE.CATEGORY.SINGULAR', visible: true, canHide: false, width: "10%", aligment: 'Center' }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Poresko oslobođenje',
            updateComponent: PoreskoOslobodjenjeModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'PORESKOOSLOBODJENJE.PLURAL'
        }
    }
    , {
        path: 'sprema',
        component: SpremaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false,
                modelName: 'sprema',
                getName: 'get',
                getParameters: [],
                modelClass: Sprema,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'SPREMA.SIFRA.SINGULAR', visible: true }
                    , { name: 'Naziv', label: 'SPREMA.NAZIV.SINGULAR', visible: true }
                    , { name: 'Nivo', label: 'SPREMA.NIVO.SINGULAR', visible: true }
                    , { name: 'Opis', label: 'SPREMA.OPIS.SINGULAR', visible: true }
                    , { name: 'Ekvivalencija', label: 'SPREMA.EKVIVALENCIJA.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Sprema',
            updateComponent: SpremaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'SPREMA.PLURAL'
        }
    }
    , {
        path: 'radnomesto',
        component: RadnoMestoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'radnomesto',
                getName: 'getRoot',
                getParameters: [],
                modelClass: RadnoMesto,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'RADNOMESTO.SIFRA.SINGULAR', visible: true, canHide: false }
                    , { name: 'Naziv', label: 'RADNOMESTO.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultListType: DefaultListType.Treeview,
                defaultPropertyName: 'Naziv'
            },
            mainTitle: 'Radno mesto',
            updateComponent: RadnoMestoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'RADNOMESTO.PLURAL'
        }
    }
    , {
        path: 'radnomestoposlovi',
        component: RadnoMestoPosloviTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                modelName: 'radnomesto',
                getName: 'getRoot',
                getParameters: [],
                modelClass: RadnoMesto,
                //shortModelClass: RadnoMesto,
                parentProperty: '',
                tableColumns: [
                    { name: 'Sifra', label: 'RADNOMESTO.SIFRA.SINGULAR', visible: true, canHide: false }
                    , { name: 'Naziv', label: 'RADNOMESTO.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultListType: DefaultListType.Treeview,
                defaultPropertyName: 'Naziv',
                detailList: [
                    {
                        modelName: 'radnomestoposlovi',
                        getName: 'getByRadnoMestoID',
                        getParamerters: [],
                        modelClass: RadnoMestoPoslovi,
                        shortModelClass: RadnoMestoPosloviView,
                        tableColumns: [
                            { name: 'Poslovi', label: 'POSLOVI.PLURAL' },
                        ],
                        sortBy: 'Poslovi',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'RadnoMestoID',
                        updateComponent: '',
                        FormType: 'reactive',
                        showOnFirstPage: true,
                        formType: FormType.Reactive
                    }
                ],
            },
            mainTitle: 'Radno mesto',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'RADNOMESTO.PLURAL'
        }
    }
    , {
        path: 'Izvestaj',
        component: RadnoMestoPosloviTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                modelName: 'izvestaj',
                getName: null,
                getParameters: [],
                modelClass: Izvestaj,
                shortModelClass: Izvestaj,
                parentProperty: '',
                tableColumns: [
                    { name: 'Opis', label: 'IZVESTAJ.OPIS.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Opis',
                sortReverse: false,
                enableEdit: true,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultPropertyName: 'Opis'
            },
            mainTitle: 'Izveštaj',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'IZVESTAJ.PLURAL'
        }
    }
    , {
        path: 'komitentobjekatupisnomesto',
        component: KomitentObjekatUpisnoMestoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.KOMITENTOBJEKATUPISNOMESTO.PLURAL',
                modelName: 'komitentobjekatupisnomesto',
                getName: 'get',
                getParameters: [],
                modelClass: KomitentObjekatUpisnoMesto,
                shortModelClass: KomitentObjekatUpisnoMestoView,
                parentProperty: 'KomitentObjekatID',
                tableColumns: [
                    { name: 'NazivUpisnogMesta', label: 'KOMITENTOBJEKATUPISNOMESTO.NAZIVUPISNOGMESTA.SINGULAR', visible: true, canHide: false }
                    , { name: 'KomitentNaziv', label: 'KOMITENTOBJEKATUPISNOMESTO.KOMITENT.SINGULAR', visible: true, canHide: false }
                    , { name: 'NazivObjekta', label: 'KOMITENTOBJEKATUPISNOMESTO.KOMITENTOBJEKAT.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'NazivUpisnogMesta',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Komitent objekat upisno mesto',
            updateComponent: KomitentObjekatUpisnoMestoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KOMITENTOBJEKATUPISNOMESTO.PLURAL'
        }
    }
    , {
        path: 'komitentkontaktosoba',
        component: KomitentKontaktOsobaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'komitentkontaktosoba',
                userRightsModelName: 'komitentkontaktosoba',
                getName: 'get',
                getParameters: [],
                modelClass: KomitentKontaktOsoba,
                shortModelClass: KomitentKontaktOsobaView,
                parentProperty: 'KomitentID',
                tableColumns: [
                    { name: 'OsobaNaziv', label: 'KOMITENTKONTAKTOSOBA.OSOBA.SINGULAR', visible: true, canHide: false }
                    , { name: 'KomitentNaziv', label: 'KOMITENTKONTAKTOSOBA.KOMITENT.SINGULAR', visible: true, canHide: false }
                    , { name: 'MestoNaziv', label: 'KOMITENTKONTAKTOSOBA.MESTO.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Komitent kontakt osoba',
            updateComponent: KomitentKontaktOsobaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KOMITENTKONTAKTOSOBA.PLURAL'
        }
    }
    , {
        path: 'language',
        component: LanguageComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'language',
                getName: 'get',
                getParameters: [],
                modelClass: Language,
                parentProperty: '',
                tableColumns: [
                    { name: 'Name', label: 'LANGUAGE.NAME.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Name',
                sortReverse: false,

                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Jezici',
            updateComponent: LanguageModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'LANGUAGE.PLURAL'
        }
    }
    , {
        path: 'vrstavozila',
        component: VrstaVozilaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.VRSTEVOZILA.PLURAL',
                modelName: 'vrstavozila',
                getName: 'get',
                getParameters: [],
                modelClass: VrstaVozila,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VRSTAVOZILA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,

            },
            mainTitle: 'VRSTA VOZILA',
            updateComponent: VrstaVozilaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VRSTAVOZILA.PLURAL'
        }
    }
    , {
        path: 'vozilo',
        component: VoziloComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.VOZILA.PLURAL',
                modelName: 'vozilo',
                getName: 'get',
                getParameters: [],
                modelClass: Vozilo,
                shortModelClass: VoziloView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VOZILO.NAZIV.SINGULAR', visible: true, canHide: false },
                    { name: 'VrstaVozila', label: 'VOZILO.VRSTAVOZILA.SINGULAR', visible: true, canHide: false },
                    { name: 'RgBr', label: 'VOZILO.RGBR.SINGULAR', visible: true, canHide: false }

                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,

            },
            mainTitle: 'VOZILO',
            updateComponent: VoziloModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VOZILO.PLURAL'
        }
    }

    , {
        path: 'firmaobjekat',
        component: FirmaObjekatComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                label: 'TABLE.KOMITENTOBJEKAT.PLURAL',
                modelName: 'firmaobjekat',
                userRightsModelName: 'firmaobjekat',
                getName: 'get',
                getParameters: [],
                modelClass: FirmaObjekat,
                shortModelClass: FirmaObjekatView,
                parentProperty: 'CompanyID',
                tableColumns: [
                    { name: 'Naziv', label: 'COMPANYOBJEKAT.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'MestoNaziv', label: 'COMPANYOBJEKAT.MESTO.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Firma objekat',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'COMPANYOBJEKAT.PLURAL'
        }
    }
    , {
        path: 'akciznaroba',
        component: AkciznaRobaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'akciznaroba',
                getName: 'get',
                getParameters: [],
                modelClass: AkciznaRoba,
                // shortModelClass: AkciznaRobaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'AKCIZNAROBA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Akcizna roba',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'AKCIZNAROBA.PLURAL'
        }
    }
    , {
        path: 'akciznarobatippakovanja',
        component: AkciznaRobaTipPakovanjaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'akciznarobatippakovanja',
                getName: 'get',
                getParameters: [],
                modelClass: AkciznaRobaTipPakovanja,
                shortModelClass: AkciznaRobaTipPakovanjaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'AKCIZNAROBA.TIPPAKOVANJA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Akcizna roba – tip pakovanja',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'AKCIZNAROBATIPPAKOVANJA.PLURAL'
        }
    }
    ,{
        path: 'komitentvozilo',
        component: KomitentVoziloComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'komitentvozilo',
                getName: 'getByKomitentID',
                getParameters: [],
                modelClass: KomitentVozilo,
                shortModelClass: KomitentVoziloView,
                parentProperty: '',
                tableColumns: [
                                { name: 'RgBr', label: 'KOMITENTVOZILO.RGBR.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'RgBr',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Komitent vozila',
            updateComponent: KomitentVoziloModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KOMITENTVOZILO.PLURAL'
        }
    }
]
